export default {
  title: {
    base: [
      'Onboarding takes only a',
      'and is entirely',
      'You can use the Healistic interface',
      'that has an internet browser.',
    ],
    keywords: [
      'couple of minutes',
      'free of charge.',
      'on any device',
    ],
  },
};
